module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-05.9b6e7f1c.png";